module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "name": _vm.inputId,
      "id": _vm.inputId,
      "value": _vm.dateValue,
      "format": _vm.customFormatter
    },
    on: {
      "selected": function($event) {
        _vm.updatedDate($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.inputId)),
      expression: "errors.has(inputId)"
    }],
    staticClass: "help is-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.inputId)))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abf555d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/date-input.vue
// module id = 553
// module chunks = 1